import {useSelector} from "react-redux";
import Archive from "./archive";
import {fileThumbnail} from "../../system/utils";
import {useTranslate} from "../../system/useTranslate";
import {Button} from "primereact/button";
import {normalizeMembershipEntity} from "../workspace-membership/workspace-membership-identity";
import {resolveUrl} from "../../system/app-config";

export function useArchive() {
    const workspaceMembership = useSelector((state) => state.app?.workspaceMembershipData);
    const memberships = workspaceMembership?.workspace?.workspace_memberships || [];
    const translate = useTranslate();

    const getArchives= async (workspaceId)=>{
        try {
            const archive = new Archive();
            // TODO: Backend must provide the 'archivedBy' workspace-membership
            // relation with its 'member' populated for every archived item.
            // If archivedBy is returned as a raw id (or omitted), the frontend
            // "Archived By" dropdown in src/pages/settings/tabs/archive.js stays empty.
            const membershipPopulate = {populate: {member: {populate: ["profileImage"]}}};
            const query = {
                filters: {
                    $and:[
                        {workspace:{$eq: workspaceId}},
                    ],
                },
                populate: {
                    tasks: {populate: {archivedBy: membershipPopulate}},
                    projects: {populate: {archivedBy: membershipPopulate}},
                    goals: {populate: {archivedBy: membershipPopulate}},
                    deliverables: {populate: {archivedBy: membershipPopulate}},
                },
            }
            const _data = await archive.getAll(query);

            const data = _data.data || {};
            return {
                tasks: (data.tasks || []).map((item) => normalizeMembershipEntity(item, "task", memberships)),
                projects: (data.projects || []).map((item) => normalizeMembershipEntity(item, "project", memberships)),
                goals: (data.goals || []).map((item) => normalizeMembershipEntity(item, "goal", memberships)),
                deliverables: (data.deliverables || []).map((item) => normalizeMembershipEntity(item, "deliverable", memberships)),
            }
        }catch (e){

        }
    }
    const prepareTable = ({actions})=>{
        const fields=["name","type","archivedBy","archivedAt","actions"]
        const value=(item)=>{
            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <Button className="cursor-pointer border-round p-button-danger p-button-text p-1 px-2 text-xs border-none shadow-none" onClick={()=>{actions?.onUnArchiveClicked?.(item)}}>{translate("unarchive")}</Button>
                </div>
            )
        }
        const icon=(item)=>{
            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <div className="h-2rem">
                        {item&&fileThumbnail(item.name, resolveUrl(item.url),"2rem", true)}
                    </div>
                    {/*<span className="pi pi-eye cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{}}/>*/}
                    {/*<span className="pi pi-file-edit cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onEditClicked({value:item})}}/>*/}
                    {/*<span className={`pi pi-power-off cursor-pointer hover:surface-100 border-circle p-3 ${item.kphwms_isonline?"text-red-500":"text-green-500"}`} onClick={()=>{actions.onPowerOffClicked({value:item})}}/>*/}
                    {/*<span className="pi pi-sync cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{console.log(item)}}/>*/}
                    {/*<span className="pi pi-trash cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onDeleteClicked({value:item})}}/>*/}
                </div>
            )
        }

        const fieldsConfig = {
            name:{type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            type:{type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            archivedBy:{type:"AVATAR_GROUP", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            archivedAt:{type:"PERSIAN_DATE", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            actions:{type:"ACTIONS", value, translate:true, "class-name":"w-3rem"},
        }
        return {fields, fieldsConfig}
    }

    return {getArchives, prepareTable};
}
